import { render, staticRenderFns } from "./GenericDialog.vue?vue&type=template&id=5ef0f045&scoped=true"
import script from "./GenericDialog.vue?vue&type=script&lang=js"
export * from "./GenericDialog.vue?vue&type=script&lang=js"
import style0 from "./GenericDialog.vue?vue&type=style&index=0&id=5ef0f045&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef0f045",
  null
  
)

export default component.exports